import Actions from "@/elements/Actions";
import axiosInterceptorInstance from "@/elements/axiosInterceptorInstance";
import optionIconGold from "@/assets/icons/optionIconGold.png";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import IndicesGraph from "../IndicesGraph";
import StockTopDetails from "../StockTopDetails";
import StocksUpDown from "./StocksUpDown";
import TopGainersLosersTable from "./TopGainersLosersTable";
import { MdChevronRight } from "react-icons/md";
import Image from "next/image";
import { BsChevronRight } from "react-icons/bs";
import OthersIndex from "./OthersIndex";
import { Mixpanel } from "@/elements/Mixpanel";
import { setSelectedPlan } from "@/store/features/paymentSlice";
import { useRouter } from "next/router";
function getLtpPrice(nscPrice, bscPrice, nscCloseProce, bseClosePrice) {
    if (nscPrice != null) {
        return nscPrice - nscCloseProce;
    } else {
        return bscPrice - bseClosePrice;
    }
}

function getpricePercentage(nscPrice, bscPrice, nscCloseProce, bseClosePrice) {
    if (nscPrice != null) {
        return ((nscPrice - nscCloseProce) / nscCloseProce) * 100;
    } else {
        return ((bscPrice - bseClosePrice) / bseClosePrice) * 100;
    }
}

export default function IndexDetailPage({
    setActive,
    preData,
    setActiveChartType,
    isPaidUserPage,
    activeChartType,
    name,
    showAll = true
}) {
    const [loading, setLoading] = useState(true);
    const { replace, asPath } = useRouter();

    const [indexData, setIndexData] = useState({});
    const [finCodeData, setFinCodeData] = useState({});

    useEffect(() => {
        var finCodes = [];
        axiosInterceptorInstance.get(`/resources/markets/companies/${name}`).then((res) => {
            finCodes.push(name);
            res.data?.topGainers?.map((ele) => finCodes.push(ele));
            res.data?.topLosers?.map((ele) => finCodes.push(ele));
            res.data?.finCode?.map((ele) => finCodes.push(ele));
            setIndexData(res.data);
            axiosInterceptorInstance
                .get(`/resources/stock-details/prices?finCodes=${finCodes}`)
                .then((res) => {
                    const updatedFincodeData = res.data?.data?.list?.reduce(
                        (obj, item) =>
                            Object.assign(obj, {
                                [item.finCode]: {
                                    ...item,
                                    value: getLtpPrice(
                                        item?.nseLtpPrice,
                                        item?.bseLtpPrice,
                                        item?.nseClosePrice,
                                        item?.bseClosePrice
                                    ),
                                    percentage: getpricePercentage(
                                        item?.nseLtpPrice,
                                        item?.bseLtpPrice,
                                        item?.nseClosePrice,
                                        item?.bseClosePrice
                                    )
                                }
                            }),
                        {}
                    );
                    setFinCodeData(updatedFincodeData);
                    return updatedFincodeData;
                })
                .then((updatedFincodeData) => {
                    axiosInterceptorInstance
                        .get(`/resources/stock-details/price-changes?finCodes=${finCodes.join(",")}`)
                        .then((response) => {
                            const netReturnsData = response.data;

                            const mergedFincodeData = { ...updatedFincodeData };
                            Object.keys(netReturnsData).forEach((finCode) => {
                                if (mergedFincodeData[finCode]) {
                                    mergedFincodeData[finCode].netReturns = netReturnsData[finCode];
                                }
                            });
                            setFinCodeData(mergedFincodeData);
                        });
                })
                .finally(() => {
                    setTimeout(() => setLoading(false), 100);
                });
        });
    }, [name]);

    return (
        <>
            {showAll && (
                <>
                    <StockTopDetails
                        preData={preData}
                        finCode={preData?.finCode}
                        activeChartType={activeChartType}
                        setActiveChartType={setActiveChartType}
                        isPaidUserPage={isPaidUserPage}
                    />
                    <IndicesGraph
                        activeChartType={activeChartType}
                        name={preData?.finCode}
                        exchange={preData?.nseSymbol ? "NSE" : "BSE"}
                    />
                    <div
                        className="rounded-2xl border border-[#EDEDED] mx-4 mt-6 p-6 flex items-center gap-3  "
                        onClick={() => {
                            Mixpanel.track("cta_clicked", {
                                page: "Index_sdp",
                                cta_text: "option_chain",
                                widget: "underlying_assets",
                                tab: "overview"
                            });
                            setActive("option-chain");
                        }}
                    >
                        <Image
                            src={optionIconGold}
                            alt="icon"
                            width={100}
                            height={100}
                            className="w-11 object-contain"
                        />
                        <div className="text-black font-Inter font-bold text-base">
                            {preData?.compName} Option Chain
                        </div>
                        <MdChevronRight size={24} className="ml-auto" />
                    </div>
                    <StocksUpDown title={preData?.nseSymbol ?? preData?.bseSymbol} />
                </>
            )}
            <TopGainersLosersTable
                stocksDetail={preData}
                fincodeData={finCodeData}
                data={indexData}
                loading={loading}
                isStockPage={!showAll}
            />
            <div
                onClick={() => {
                    Mixpanel.track("page_viewed", {
                        page: "Index_sdp",
                        widget: "company_table",
                        cta_clicked: "view_all"
                    });
                    const tempPath = asPath?.split("?")?.[0];
                    if (tempPath?.includes("-share-price-today")) {
                        const path = tempPath?.includes("-share-price-today/")
                            ? tempPath?.replace(tempPath?.split("/")?.[tempPath?.split("/")?.length - 1], "stocks")
                            : `${tempPath}/stocks`;
                        replace(path);
                    } else {
                        setActive("stocks");
                    }
                }}
                className="text-[#00439D] text-center text-xs font-medium leading-5 flex flex-row gap-2 justify-center items-center mt-3 mb-4"
            >
                View all <BsChevronRight />
            </div>
            <OthersIndex name={preData?.finCode} />
        </>
    );
}
